import { DescriptionOutlinedIcon, NoRowsOverlay } from '@shared/components';

import { GenerateQSetButton } from '../generate-qset-button';

export default function DraftQSetListNoRowsOverlay() {
  return (
    <NoRowsOverlay
      title='ยังไม่มีชุดข้อสอบ'
      description='เริ่มสร้างชุดข้อสอบใหม่ได้ที่เมนู “QSet Generator”'
      icon={DescriptionOutlinedIcon}
      action={
        <GenerateQSetButton size='large' variant='outlined'>
          Go to QSet Generator
        </GenerateQSetButton>
      }
    />
  );
}
